import {BasePopup} from "components"
import PhaseTable from "./PhaseTable"

type Props = {
    isVisible: boolean
    onClose: () => void
    academicTrackId?: number
    onRefresh: () => void
}

const SelectPhasePopup = (props: Props) => {
    const {isVisible, onClose, onRefresh, academicTrackId} = props

    return isVisible ? (
        <BasePopup onCancel={onClose} isShow={isVisible} onClose={onClose} leftIcon="FILE_LINE_ALT" width="50vw">
            <PhaseTable
                onClose={onClose}
                isVisible={isVisible}
                onRefresh={onRefresh}
                academicTrackId={academicTrackId}
            />
        </BasePopup>
    ) : null
}

export default SelectPhasePopup
